import * as Yup from "yup";
import { useNavigate, useLocation } from "react-router-dom";
import { useRef, useState, useEffect } from "react";
import Layoutcreatepage from "../../../components/common/Form/Create-Layout";
import { useUpdateBranchMutation } from "../../../store/api/branch";

const BranchEdit = () => {
  const feedback = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [updatebranch] = useUpdateBranchMutation();
  const [initialValues, setInitialValues] = useState(null);
  const [feedbackMessage, setFeedbackMessage] = useState({
    type: "",
    message: "",
  });
  
  const editGym = location?.state?.data;
 
  const fields = [
    { name: "branch_name", label: "Branch Name", type: "text", placeholder: "Enter Branch Name",hidden:false, required:true }
  ];

  useEffect(() => {
  
      if (editGym) {
        setInitialValues({
          branch_name: editGym.branch_name || "",

        });
      }

  }, [editGym]);
  
  const validationSchema = Yup.object({
    branch_name: Yup.string().required(" Branch name  is required"),
  });
  

    const handleCancel = () => {
      navigate("/gym-branch-list",{ state: { pageName: "Branch" } });
    };

  const onSubmit = async (values, { setSubmitting }) => {
    setLoading(true);
    try {
    const formData = {
      branch_name: values.branch_name
    }
      
      const response = await updatebranch({ id: editGym.id, branchData: formData });
      if(response.error){
        setFeedbackMessage({
          type: "error",
          message: response?.error?.data?.error || "Update failed.",
        });
      }else{
      if (response.data.branch_name === values.branch_name) {
        setFeedbackMessage({
          type: "success",
          message: "Branch Updated succesfully!",
        });

        setTimeout(() => navigate("/gym-branch-list" ,{ state: { pageName: "Branch" } }), 3000);
      } 
    }
    } catch (error) {
      console.error("Error calling API:", error);
      setFeedbackMessage({
        type: "error",
        message: error?.message || "Something went wrong.",
      });
    } finally {
      setSubmitting(false);
      setLoading(false);
    }
  };

  return (
    <div className="pb-4 pt-3 ">
      {initialValues && fields.length > 0 && (
        <Layoutcreatepage
          title="Edit Branch"
        validationSchema={validationSchema}
          fields={fields}  
          feedback={feedback}
          onSubmit={onSubmit}
          initialValues={initialValues}
          buttonText="Edit GYM"
          navigateTo="/gym-list"
          loading={loading}
          feedbackMessage={feedbackMessage}
          onCancel={handleCancel} 
        />
      )}
    </div>
  );
};
export default BranchEdit;
